import { notification } from "antd";
import produce from "immer";

const INITIAL_STATE = [];

const Notification = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "INIT":
      return action.payload;
    case "REMOVE_NOTIF":
      return state.filter((item) => item.id !== action.payload);
    case "SEEN":
      return produce(state, (draft) => {
        const item = draft.find((item) => item.id === action.payload);
        if (item) {
          item.seen = true;
        }
      });
    case "ADD_NOTIF":
      return [action.payload, ...state];
    default:
      return state;
  }
};
export default Notification;
